import React, { MouseEvent } from 'react';
import { IconClose } from '@/components/icons';

type DialogTopBarProps = {
	closeBox: (e: MouseEvent<HTMLButtonElement>) => void;
};

const DialogTopBar = (props: DialogTopBarProps) => {
	const { closeBox } = props;
	return (
		<div
			data-testid="DialogTopBar"
			className="mx-auto flex w-full flex-row items-center justify-between px-6 py-6"
		>
			<p className="text-balance text-lg font-semibold">
				Get answers to your HVAC questions
			</p>
			<button data-testid="CloseButton" className="" onClick={closeBox}>
				<IconClose className="fill-slate-600" />
			</button>
		</div>
	);
};

export default DialogTopBar;
